import React, { useEffect, useState } from "react";
import { BiLogIn } from "react-icons/bi";
import config from "../../config/config";
import pcssLogo from "../../images/pcss-logo.png";
import sideImage from "../../images/image.png";
import "./style.scss";
import Navbar from "../Shared/Navbar";
import Footer from "../Shared/Footer";
import Loader from "../Shared/Loader";

const Auth = (user) => {
  const { SSO_LOGIN_URL } = config;
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

   useEffect(() => {
        document.title = 'Login | Product Catalogue'; //added to change tab title in browser
    }, []);
    
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch("/api/user", {
          credentials: "include",
        });

        if (response.ok) {
          await response.json(); // We can lift state to App if needed
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
        }
      } catch (error) {
        console.error("Auth error:", error);
        setLoggedIn(false);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);
  const handleLogin = (user) => {
    window.location.href = SSO_LOGIN_URL;
  };
  if (loading) return <Loader />;

  if (loggedIn) return null;
  return (
    <>
      <div className="wrapper">
        <Navbar />
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-10 col-lg-9 mx-auto">
              <div className="card bg-white rounded-5 overflow-hidden shadow-lg">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6 d-none d-lg-block">
                      <img src={sideImage} className="img-fluid" alt="" />
                    </div>
                    <div className="col-lg-6">
                      <div className="login-section">
                        <img src={pcssLogo} className="pcss-logo" alt="" />
                        <div className="m-auto text-center p-5 p-md-4">
                          <p className="mb-4">
                            A centralized repository of our product and service
                            offerings, providing a standardized interface for
                            discovery, exploration and integration. This
                            catalogue enables seamless access to our solutions.
                          </p>
                          <button
                            className="btn btn-outline-dark rounded-pill btn-login px-2 px-md-4"
                            onClick={handleLogin}
                          >
                            <BiLogIn className="me-2 me-lg-3 fs-4" />
                            <span>Login with SAML</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Auth;

// ------------------------------
// Usage Example for Auth Logic:
// ------------------------------
// const [loading, setLoading] = useState(true);
// const [loggedIn, setLoggedIn] = useState(false);
// useEffect(() => {
//   const checkAuth = async () => {
//     try {
//       const response = await fetch("/api/user", { credentials: "include" });
//       if (response.ok) {
//         setLoggedIn(true);
//       } else {
//         setLoggedIn(false);
//       }
//     } catch (error) {
//       setLoggedIn(false);
//     }
//     setLoading(false);
//   };
//   checkAuth();
// }, []);
// if (loading) return <Loader />;
// if (!loggedIn) return <Redirect to="/login" />;
// ------------------------------
